import React, { useState } from 'react';
import Modal from 'react-modal';
import CloseIcon from '../../layouts/components/closeicon';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const PortfolioItem = ({ ...data }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    return (
        <div className={`col-lg-4 col-md-6 portfolio-item ${data.filterClass} mb-4`}>
            <div className="portfolio-wrap shadow-sm rounded overflow-hidden bg-white border" onClick={openModal} style={{ cursor: 'pointer' }}>
                {data.imageSrc && (
                    <img 
                        src={data.imageSrc} 
                        className="img-fluid w-100" 
                        alt={data.title} 
                        style={{ height: '220px', objectFit: 'cover' }} 
                    />
                )}
                <div className="p-3">
                    <h5 className="fw-bold text-dark mb-1">{data.title}</h5>
                    <p className="text-muted small mb-3">{data.stack}</p>
                    <p className="text-secondary small">{data.description}</p>

                    <div className="d-flex justify-content-between align-items-center mt-3 border-top pt-3">
                        <div className="d-flex align-items-center text-muted small">
                            <i className={`${data.iconClass} me-2`} style={{ color: '#34b7a7' }}></i>
                            <span>{data.footerText}</span>
                        </div>
                    </div>
                </div>
            </div>

            <Modal 
                style={{
                    overlay: {
                        position: 'fixed',
                        zIndex: 1000,
                        backgroundColor: 'rgba(255, 255, 255, 0.75)'
                    }
                }}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Portfolio Details"
            >
                <div className="d-flex justify-content-end">
                    <button className="modal-close-btn btn text-dark" onClick={closeModal}>
                        <CloseIcon />
                    </button>
                </div>
                <section id="portfolio-details" className="portfolio-details">
                    <main id="main">
                        <section id="portfolio-details" className="portfolio-details">
                            <div className="container">
                                <div className="row gy-4">
                                    <div className="col-lg-8">
                                        <div className="portfolio-details-slider swiper">
                                            {data.imageSrc ? (
                                                <Swiper
                                                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                                                    spaceBetween={50}
                                                    slidesPerView={1}
                                                    navigation
                                                    pagination={{ clickable: true }}
                                                    scrollbar={{ draggable: true }}
                                                >
                                                    <SwiperSlide>
                                                        <img src={data.imageSrc} alt="" className="img-fluid" />
                                                    </SwiperSlide>
                                                </Swiper>
                                            ) : (
                                                <div className="p-5 bg-light rounded text-center text-muted">
                                                    No preview image available for this system architecture item.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="portfolio-info">
                                            <h3>Project information</h3>
                                            <ul>
                                                <li><strong>Category</strong>: {data.footerText}</li>
                                                <li><strong>Stack</strong>: {data.stack}</li>
                                                {data.githubUrl && (
                                                    <li>
                                                        <strong>Project Github URL:</strong>
                                                        {data.githubUrl.map((link, idx) => (
                                                            <a key={idx} className='mx-1' href={link.link}>{link.text}</a>
                                                        ))}
                                                    </li>
                                                )}
                                                {data.projectPublicUrl && (
                                                    <li>
                                                        <strong>Project Public URL:</strong>{' '}
                                                        <a href={data.projectPublicUrl.link}>{data.projectPublicUrl.text}</a>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        <div className="portfolio-description">
                                            <h2>{data.title}</h2>
                                            <p>{data.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </section>
            </Modal >
        </div >
    );
};

export default PortfolioItem;